
import React, { Component } from 'react';

import { FormContext } from 'core/FormProvider';
import { ContextWidget, ContextFormControlWidget } from 'form/Contexed';
import { InputWidget, InputNumberWidget } from 'form/InputWidget';
import { SelectWidget } from 'form/Select';
import { CheckboxWidget } from 'form/Checkbox';
import { DateWidget } from 'form/new/DateWidget';
import FormGroup from 'form/FormGroup';
import { Grid } from 'ui/Grid';


function FormDateWidget({ onChange, ...props }) {
  return <DateWidget {...props} onChange={(value, stringValue) => onChange(stringValue)} />;
}


export class TractorUnitForm extends Component {

  render() {
    return (
      <FormContext.Consumer>
        {() => {
          return (
            <FormGroup>
              <div className={'mb-15'}>
                <ContextWidget
                  name={'is_active'}
                  WidgetComponent={CheckboxWidget}
                  widgetProps={{
                    label: 'Активность'
                  }}
                />
              </div>
              <ContextWidget
                name={'number'}
                WidgetComponent={InputWidget}
                widgetProps={{
                  label: 'Регистрационный знак',
                  required: true,
                  toUpperCase: true
                }}
              />
              <ContextWidget
                name={'brand'}
                WidgetComponent={InputWidget}
                widgetProps={{
                  label: 'Марка'
                }}
              />
              <ContextWidget
                name={'model'}
                WidgetComponent={InputWidget}
                widgetProps={{
                  label: 'Модель'
                }}
              />
              <ContextWidget
                name={'year'}
                WidgetComponent={InputNumberWidget}
                widgetProps={{
                  label: 'Год выпуска'
                }}
              />
              <ContextWidget
                name={'color'}
                WidgetComponent={InputWidget}
                widgetProps={{
                  label: 'Цвет кабины'
                }}
              />
              <ContextWidget
                name={'work_phone'}
                WidgetComponent={InputWidget}
                widgetProps={{
                  label: 'Рабочий телефон'
                }}
              />
              <ContextWidget
                name={'vin'}
                WidgetComponent={InputWidget}
                widgetProps={{
                  label: 'VIN',
                  toUpperCase: true,
                  inputProps: { maxLength: 17 }
                }}
              />
              <ContextFormControlWidget
                name={'tachograph'}
                label={'Тахограф'}
                WidgetComponent={SelectWidget}
                widgetProps={{
                  label: 'Тахограф',
                  options: [
                    {value: 'skzi', label: 'СКЗИ'},
                    {value: 'estr', label: 'ЕСТР'},
                  ]
                }}
              />
              <h3>ПТС</h3>
              <Grid columns={'1fr 1fr'}>
                <ContextWidget
                  name={'pts_series'}
                  WidgetComponent={InputWidget}
                  widgetProps={{
                    label: 'Серия'
                  }}
                />
                <ContextWidget
                  name={'pts_number'}
                  WidgetComponent={InputWidget}
                  widgetProps={{
                    label: 'Номер'
                  }}
                />
              </Grid>
              <ContextWidget
                name={'pts_date'}
                WidgetComponent={FormDateWidget}
                widgetProps={{
                  label: 'Дата выдачи'
                }}
              />
              <h3>СОР</h3>
              <Grid columns={'1fr 1fr'}>
                <ContextWidget
                  name={'sor_series'}
                  WidgetComponent={InputWidget}
                  widgetProps={{
                    label: 'Серия'
                  }}
                />
                <ContextWidget
                  name={'sor_number'}
                  WidgetComponent={InputWidget}
                  widgetProps={{
                    label: 'Номер'
                  }}
                />
              </Grid>
              <ContextWidget
                name={'sor_date'}
                WidgetComponent={FormDateWidget}
                widgetProps={{
                  label: 'Дата выдачи'
                }}
              />
              <ContextWidget
                name={'description'}
                WidgetComponent={InputWidget}
                widgetProps={{
                  label: 'Описание',
                  multiline: true
                }}
              />
            </FormGroup>
          )
        }}
      </FormContext.Consumer>
    )
  }
}
